import { GraphQLInputObjectType, GraphQLNonNull } from 'graphql'
import { mapLibraryFilters } from '../endpoint-helpers'
import {
  LibraryFilterArg,
  libraryFilterArgType
} from '../types/library-filter-arg'
import {
  buildMutationModuleExports,
  commonTypes,
  FieldsConfig
} from './builder'

type FieldConfigKey =
  | 'organizationID'
  | 'filters'
  | 'libraryHashesToExclude'
  | 'applicationID'

const fieldsConfig: FieldsConfig<FieldConfigKey> = {
  organizationID: {
    description:
      'The ID of the organization of the application libraries being deleted',
    ...commonTypes.typeRequiredId
  },
  filters: {
    description: 'Filters to use when searching for libraries',
    type: new GraphQLNonNull(libraryFilterArgType),
    typeString: 'LibraryFilterArg!'
  },
  libraryHashesToExclude: {
    description: 'A list of library hashes to exclude from the filters',
    ...commonTypes.typeRequiredListOfStrings
  },
  applicationID: {
    description: 'The application associated with the libraries to be deleted',
    ...commonTypes.typeRequiredString
  }
}

interface ArgsInputType {
  readonly filters: LibraryFilterArg
  readonly organizationID: string
  readonly libraryHashesToExclude: string[]
  readonly applicationID: string
}

export const resolve: (
  connector,
  input: ArgsInputType
) => Promise<void> = async (
  { executeDelete },
  { filters, organizationID, libraryHashesToExclude, applicationID }
) => {
  await executeDelete(
    `${organizationID}/applications/${applicationID}/libraries/filters`,
    {
      ...mapLibraryFilters(filters),
      libraryHashesToExclude
    }
  )
}

export const { mutationName, mutation, mutationString, mutationConfig } =
  buildMutationModuleExports<ArgsInputType, FieldConfigKey>({
    mutationName: 'deleteAppLibrariesWithFilters',
    description: 'Delete one or more application libraries via filters',
    inputType: new GraphQLInputObjectType({
      name: 'DeleteAppLibrariesByFiltersMutationArg',
      fields: fieldsConfig
    }),
    fieldsConfig,
    resolve
  })
